import React, { useMemo } from 'react';

// ===============================================
// 🎨 PALETTE (Définie pour la FilterBar)
// Nous devons la redéfinir ici car FilterBar est un composant séparé
// ===============================================
const COLOR_PRIMARY = "#4DD0E1"; 
const COLOR_SECONDARY = "#26C6DA"; 
const COLOR_TEXT_DARK = "#333333";
const COLOR_GRAY_DARK = "#6c757d"; // Gris pour le bouton d'annulation

const FilterBar = ({ filter, setFilter, type, categories, styles, filteredCount, totalCount }) => {
    const isFacture = type === 'facture';
    const filterCategories = [{ id: '', name: 'Toutes catégories' }, ...categories];

    const isFilterActive = useMemo(() => {
        return Object.entries(filter).some(([key, value]) => {
            if (key === 'categorieId') {
                return value !== '' && value !== '0' && Number(value) > 0;
            }
            return value !== '' && value !== null && value !== undefined;
        });
    }, [filter]);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilter(prev => ({ ...prev, [name]: value }));
    };

    const handleReset = () => {
        const initialState = {
            startDate: '',
            endDate: '',
            categorieId: '',
            description: '',
            minAmount: '',
            maxAmount: '',
        };
        setFilter(initialState);
    };
    
    // 💡 Styles Locaux Basés sur la Palette (Évite de dépendre entièrement des styles.js du parent)
    const localStyles = {
        filterBar: {
            backgroundColor: '#F5F5F5', // Fond blanc pour le filtre
            padding: '15px',
            borderRadius: '8px',
            marginBottom: '10px',
            border: `1px solid ${COLOR_PRIMARY}50`,
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        },
        filterTitle: {
            margin: '0 0 15px 0',
            color: COLOR_TEXT_DARK,
        },
        activeFilterIndicator: {
            color: COLOR_SECONDARY,
            fontWeight: 'normal',
        },
        resetButton: {
            backgroundColor: COLOR_GRAY_DARK,
            color: '#fff',
            padding: '13px', 
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: 'bold',
            transition: 'background-color 0.2s',
            "&:hover": {
                backgroundColor: '#5a6268',
            }
        },
        // Réutilise les styles input du parent (DashboardPage) via la prop 'styles'
    };

    return (
        <div style={localStyles.filterBar}>
            <h4 style={localStyles.filterTitle}>
                Filtres {isFacture ? 'Factures' : 'Opérations'}
                {isFilterActive && (
                    <span style={localStyles.activeFilterIndicator}>
                        {" (Filtres actifs 💡)"}
                    </span>
                )}
            </h4>
            
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'flex-end' }}>
                <input 
                    type="date"
                    name="startDate"
                    value={filter.startDate}
                    onChange={handleFilterChange}
                    style={{ ...styles.input, flexGrow: 1 }}
                    title="Date Début"
                />
                <input 
                    type="date"
                    name="endDate"
                    value={filter.endDate}
                    onChange={handleFilterChange}
                    style={{ ...styles.input, flexGrow: 1 }}
                    title="Date Fin"
                />
                
                <select
                    name="categorieId"
                    value={filter.categorieId}
                    onChange={handleFilterChange}
                    style={{ ...styles.input, flexGrow: 2 }}
                >
                    {filterCategories.map(c => (
                        <option key={c.id || 0} value={String(c.id)}>{c.name}</option> 
                    ))}
                </select>

                <input 
                    type="text"
                    name="description"
                    value={filter.description}
                    onChange={handleFilterChange}
                    style={{ ...styles.input, flexGrow: 2 }}
                    placeholder="Libellé / Description"
                />

                <input 
                    type="number"
                    step="0.01"
                    name="minAmount"
                    value={filter.minAmount}
                    onChange={handleFilterChange}
                    style={{ ...styles.input, width: '100px' }}
                    placeholder="Minimum"
                    title="Montant minimum"
                />
                <input 
                    type="number"
                    step="0.01"
                    name="maxAmount"
                    value={filter.maxAmount}
                    onChange={handleFilterChange}
                    style={{ ...styles.input, width: '100px' }}
                    placeholder="Maximum"
                    title="Montant maximum"
                />

                <button 
                    type="button" 
                    onClick={handleReset} 
                    style={localStyles.resetButton}
                >
                    Réinitialiser
                </button>
            </div>
            
            <p style={{ marginTop: '10px', fontSize: '0.9em', color: COLOR_TEXT_DARK }}>
                {isFacture 
                  ? `Factures affichées : ${filteredCount} / Total : ${totalCount}`
                  : `Opérations affichées : ${filteredCount} / Total : ${totalCount}`
                }
            </p>
        </div>
    );
};

export default React.memo(FilterBar);